import React from 'react'
import { Route } from 'react-router-dom'
import DiamondList from './components/diamond/List'
import DiamondForm from './components/diamond/Form'
import DiamondCSVUploadForm from './components/diamond/CSVUploadForm'
import AccountForm from './components/account/Form'
import SingleProdReview from '../admin/components/product-review/SingleProdReview'

export const DiamondRoutes = (
  <Route path="inventory">
    <Route index element={<DiamondList />} />
    <Route path=":diamondId/edit" element={<DiamondForm />} />
    <Route path="new" element={<DiamondForm />} />
    <Route path="csvUpload" element={<DiamondCSVUploadForm />} />
  </Route>
)

export const DiamondRoutesNew = (
  <Route path="productReview">
    <Route index element={<SingleProdReview />} />
  </Route>
)

export const AccountRoutes = <Route path="account" element={<AccountForm />} />
